import { render, staticRenderFns } from "./CategoryDetail.vue?vue&type=template&id=6a02986e&scoped=true&"
import script from "./CategoryDetail.vue?vue&type=script&lang=js&"
export * from "./CategoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDetail.vue?vue&type=style&index=0&id=6a02986e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a02986e",
  null
  
)

export default component.exports